import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { setLanguage } from '../helpers'
//PAGES
import Home from '../pages/Home'
import Faqs from '../pages/Faqs'
import About from '../pages/About'
import Itineraries from '../pages/Itineraries'
import ItineraryDetail from '../pages/ItineraryDetail'
import Mice from '../pages/Mice'
import MiceContact from '../pages/MiceContact'
import Contact from '../pages/Contact'
import Tourbooks from '../pages/Tourbooks'
import NotFound from '../pages/NotFound'

const Routes = ({ supportedLanguages }) => {
    const getLanguage = setLanguage()
    const language = supportedLanguages.find((lang) => lang === getLanguage) || 'es'

    return (
        <>
            <Switch>
                <Route exact path={['/', '/:lang/home', '/:lang/inicio', '/:lang/comeco']} component={Home} />
                <Route
                    path={['/:lang/faqs', '/:lang/preguntas-frecuentes', '/:lang/preguntas-frequentes']}
                    component={Faqs}
                />
                <Route path={['/:lang/about', '/:lang/nosotros', '/:lang/nos']} component={About} />
                <Route
                    path={['/:lang/itinerario', '/:lang/itinerarios', '/:lang/itineraries']}
                    component={Itineraries}
                />
                <Route
                    path={[
                        '/:lang/detalhe-itinerario/:slug',
                        '/:lang/detalle-itinerario/:slug',
                        '/:lang/itinerary-detail/:slug',
                    ]}
                    component={ItineraryDetail}
                />
                <Route
                    path={[
                        '/:lang/reuniones-incentivos-conferencias-exhibiciones',
                        '/:lang/mice',
                        '/:lang/reunioes-incentivos-conferencias-exposiçoe',
                    ]}
                    component={Mice}
                />
                <Route
                    path={['/:lang/mice-contacto', '/:lang/mice-contact', '/:lang/mice-contato']}
                    component={MiceContact}
                />

                <Route path={['/:lang/contact', '/:lang/contacto', '/:lang/contato']} component={Contact} />
                <Route
                    path={['/:lang/manuales-tourbooks', '/:lang/manuals-tourbooks', '/:lang/manuais-tourbooks']}
                    component={Tourbooks}
                />

                <Route
                    exact
                    path="/:lang/"
                    render={(props) =>
                        supportedLanguages.includes(props.match.params.lang) ? (
                            <Home {...props} />
                        ) : (
                            <Redirect to={`/${language}/${props.match.params.lang}`} />
                        )
                    }
                />

                <Route>
                    <NotFound />
                </Route>
            </Switch>
        </>
    )
}

export default Routes
